<section class="tp-error-area pt-60 pb-110">
    <div class="container col-xl-6 col-lg-8 col-md-10">
        <div *ngIf="isPhoneVerified || isPhoneVerificationSkipped">
            <h2 class="text-center">
                {{ "RegistrationConfirmation.title" | translate }}
            </h2>
            <div class="w-350 m-auto mt-4">
                <p class="fs-medium">
                    {{
                        "RegistrationConfirmation.1stSentence"
                            | translate: { username: user?.name ?? "{username}" }
                    }}
                </p>
                <p class="fs-medium">
                    {{ "RegistrationConfirmation.2ndSentence" | translate }}
                </p>
                <p class="fs-medium">
                    {{ "RegistrationConfirmation.3rdSentence" | translate }}
                </p>
            </div>
            <div *ngIf="!isCardAdded">
                <div class="col-8 mx-auto pb-0">
                    <vb-add-payment-information-form
                        [isFromRegistration]="true"
                        (isCardAdded)="isCardAdded = $event">
                    </vb-add-payment-information-form>
                </div>
                <div class="w-350 m-auto d-flex mt-4">
                    <button
                        (click)="goToAllAuctions()"
                        class="btn btn-secondary text-light mx-auto align-self-center">
                        Skip This Step & View Auctions
                    </button>
                </div>
            </div>
            <div *ngIf="isCardAdded" class="text-center">
                <h5 class="text-success bold">Payment method successfully added</h5>
                <p class="fs-medium">Where would you like to go first?</p>
                <div class="w-350 m-auto d-flex mt-4">
                    <button
                        (click)="goToAllAuctions()"
                        class="btn btn-secondary text-light mx-auto align-self-center">
                        View Auctions
                    </button>
                    <button
                        (click)="goToUserProfile()"
                        class="btn btn-primary text-light mx-auto align-self-center">
                        View Profile
                    </button>
                </div>
            </div>
        </div>
        <vb-verify-phone-number *ngIf="!isPhoneVerified && !isPhoneVerificationSkipped" (isPhoneNumberVerified)="isPhoneNumberVerified($event)" (skipVerification)="skipTelephoneVerification()" />
    </div>
</section>
